@if (hasBreakfast(room.rateDescription, room.roomDescription, room.policies?.general)) {
  <section (mouseleave)="tt2.close()" class="container">
    <img
      class="toast-icon"
      src="https://images.sabscorp.com/images/Corporate/BedandBreakfast1.png"
      ngbTooltip="Hotel rates may include breakfast; however, this is not guaranteed. Please refer to the specific booking policy or the full rate description for confirmation. "
      i18n-ngbTooltip
      alt="Hotel rates may include breakfast; however, this is not guaranteed. Please refer to the specific booking policy or the full rate description for confirmation. "
      i18n-alt
      triggers="manual"
      tooltipClass="breakfast-tooltip"
      #tt2="ngbTooltip"
      (mouseenter)="tt2.open()"
      (focus)="tt2.open()"
      (blur)="tt2.close()"
      tabindex="0"
    />
  </section>
}
